import { LayerType, type IExportBehavior, type ILayerBehavior } from '@/version-types';
import {
    createEditingBehaviors,
    createOperationBehaviors,
    createRendererBehaviors,
    createSaveBehaviors,
    createTextBehaviors,
} from './behaviors';

const getBehavior = (identity: string) => {
    const rendererBehaviors = createRendererBehaviors(identity);
    const saveBehaviors = createSaveBehaviors(identity);
    const textBehaviors = createTextBehaviors(identity);
    const operationsBehaviors = createOperationBehaviors(identity);
    const editingBehaviors = createEditingBehaviors(identity);

    const layerBehavior: ILayerBehavior = {
        ...rendererBehaviors,
        ...saveBehaviors,
        ...textBehaviors,
        ...operationsBehaviors,
        ...editingBehaviors,
    };

    return layerBehavior;
};

export default {
    layerType: LayerType.VECTOR_LAYER,
    getBehavior,
} as IExportBehavior;
